import Home from "../Home/Home";
import About from "../Home/About/About";
import Contact from "../Home/Contact/Contact";
import InnovationWalkaway from "../Home/InnovationWalkway/InnovationWalkway";
import Blog from "../Home/Blog/Blog";
import Testimony from "../Home/Testimony/Testimony";
import CastingProcess from "../CastingProcess/CastingProcess";
import Products from "../ProductGallery/Product";
import ImageGallery from "../ImageGallery/ImageGallery";

type RenderPageProps = {
  mode: "default" | "learn";
};

const RenderPage = ({ mode }: RenderPageProps) => {
  return (
    <>
      <section id="home" className="min-h-screen">
        <Home />
      </section>

      {mode === "default" && (
        <>
          <section id="about" className="min-h-screen">
            <About />
          </section>

          <section id="innovation" className="min-h-screen">
            <InnovationWalkaway />
          </section>

          <section id="blog" className="min-h-screen">
            <Blog />
          </section>

          <section id="testimony" className="min-h-screen">
            <Testimony />
          </section>

          <section id="contact" className="min-h-screen">
            <Contact />
          </section>
        </>
      )}

      {mode === "learn" && (
        <>
          <section id="products" className="min-h-screen">
            <Products />
          </section>

            <section id="imageGallery" className="min-h-screen">
            <ImageGallery />
          </section>

          <section id="process" className="min-h-screen">
            <CastingProcess />
          </section>
        </>
      )}
    </>
  );
};

export default RenderPage;
